import { render, staticRenderFns } from "./BlogPostCardFilters1.vue?vue&type=template&id=1c4b3422&"
import script from "./BlogPostCardFilters1.vue?vue&type=script&lang=js&"
export * from "./BlogPostCardFilters1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports